/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';

import LoadingSpinner from '../LoadingSpinner';

const styles = cssMap({
	loadingContainer: {
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		backgroundColor: '#111213',
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		minHeight: '100vh',
		WebkitFontSmoothing: 'antialiased',
		MozOsxFontSmoothing: 'grayscale',
	},
	nonMobileLoadingContainer: {
		display: 'unset',
		'@media (max-width: 30rem)': {
			display: 'none',
		},
	},
	mobileLoadingContainer: {
		display: 'none',
		'@media (max-width: 30rem)': {
			display: 'unset',
		},
	},
});

export const LoadingView = (): JSX.Element => (
	<div css={styles.loadingContainer}>
		<div css={styles.mobileLoadingContainer}>
			<LoadingSpinner size="large" />
		</div>
		<div css={styles.nonMobileLoadingContainer}>
			<LoadingSpinner size="xlarge" />
		</div>
	</div>
);
